/**
 * @generated SignedSource<<dbfa4621e3634302cd02efd173e19761>>
 * @relayHash b284c84763ce7c7b6d50d2d3977aa1d3
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID b284c84763ce7c7b6d50d2d3977aa1d3

import { ConcreteRequest } from 'relay-runtime';
export type Country = "CH" | "DE";
export type de_BetterDocRecommendationState = "ADMISSION_FAILED" | "ADMITTED" | "ADMITTING" | "MEDIC_CONFIRMED" | "MEDIC_SELECTED" | "NO_SERVICE" | "PENDING" | "RECOMMENDED" | "REJECTED" | "RESEARCHING" | "RESEARCH_FAILED" | "SERVICE_TRIAGE_FAILED" | "TRIAGING";
export type de_BetterDocRemoteRequestStatus = "INVALID_RECOMMENDATION_ID" | "NOT_FOUND" | "RECEIVED" | "REQUEST_FAILED" | "UNEXPECTED_RESPONSE";
export type betterDocRecommendedRecommendationsQuery$variables = {
  insuranceCountry: Country;
};
export type betterDocRecommendedRecommendationsQuery$data = {
  readonly de_betterDocRecommendedRecommendations: {
    readonly errorReason: string | null;
    readonly exchangeId: number | null;
    readonly httpStatusCode: number | null;
    readonly recommendations: ReadonlyArray<{
      readonly localSessionId: number | null;
      readonly medics: ReadonlyArray<{
        readonly selectionId: number | null;
      }>;
      readonly partnerPatientId: string | null;
      readonly partnerSessionId: string | null;
      readonly recommendationId: string | null;
      readonly selectedMedic: {
        readonly name: string | null;
      } | null;
      readonly selectionId: number | null;
      readonly selectionType: string | null;
      readonly state: de_BetterDocRecommendationState | null;
      readonly version: number | null;
    }>;
    readonly status: de_BetterDocRemoteRequestStatus;
  };
};
export type betterDocRecommendedRecommendationsQuery = {
  response: betterDocRecommendedRecommendationsQuery$data;
  variables: betterDocRecommendedRecommendationsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "insuranceCountry"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "selectionId",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "insuranceCountry",
        "variableName": "insuranceCountry"
      }
    ],
    "concreteType": "de_BetterDocOpenRecommendationsResult",
    "kind": "LinkedField",
    "name": "de_betterDocRecommendedRecommendations",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "status",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "httpStatusCode",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "errorReason",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "exchangeId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "de_BetterDocOpenRecommendation",
        "kind": "LinkedField",
        "name": "recommendations",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "recommendationId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "state",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "version",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "partnerPatientId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "partnerSessionId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "localSessionId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "selectionType",
            "storageKey": null
          },
          (v1/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "de_BetterDocRemoteMedic",
            "kind": "LinkedField",
            "name": "medics",
            "plural": true,
            "selections": [
              (v1/*:: as any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "de_BetterDocRemoteMedic",
            "kind": "LinkedField",
            "name": "selectedMedic",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "betterDocRecommendedRecommendationsQuery",
    "selections": (v2/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "betterDocRecommendedRecommendationsQuery",
    "selections": (v2/*:: as any*/)
  },
  "params": {
    "id": "b284c84763ce7c7b6d50d2d3977aa1d3",
    "metadata": {},
    "name": "betterDocRecommendedRecommendationsQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "a29034813ebd1841db9c0a8c27fedd34";

export default node;
